module.exports = __webpack_public_path__ + "img/vibrant.0904721.svg";